module.exports = __webpack_public_path__ + "static/img/banner-2.26f88ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/banner/banner-2.png
// module id = LMRz
// module chunks = 1